<template>
    <v-layout class="bodyLogin" align-center justify-center row fill-height>
        <v-card class="pa-5 elevation-0" width="700" style="border-radius: 5px;">
            <img class=" mb-5 " width="425" src="../assets/astandes.png" style="display:block;margin:auto;" />
            <v-text-field box label="Login" v-model="user.login" color="blue-grey" @keyup.enter="logar" ></v-text-field>
            <v-text-field box label="Senha" v-model="user.senha"  color="blue-grey" @keyup.enter="logar" :append-icon="showPass ? 'visibility_off' : 'visibility'" :type="showPass ? 'text':'password'" @click:append="showPass=!showPass"></v-text-field>
            <!--<v-btn round style="background-color: #59BDB3" color="white--text" block="block" @click="logar">
                <v-icon>lock_open</v-icon> <span class="font-weight-bold subheading">Entrar</span>
            </v-btn>-->
            <v-btn
            :loading="loader"
            :disabled="loader || !user.login || !user.senha"
            class="white--text mb-3"
            style="background-color: #59BDB3"
            block
            large
            round
            @click="logar"
            >
            <v-icon left dark v-html="loader || !user.login || !user.senha ? 'lock' : 'lock_open'"></v-icon>
            Entrar
            <template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon light>cached</v-icon>
                    </span>
            </template>
            </v-btn>
            <v-layout justify-space-between row>
                <v-btn round class="elevation-0 ma-0" @click="dialog=true">
                    <v-icon left>
                        lock
                    </v-icon>
                    <small>
                        Esqueci minha senha
                    </small>
                </v-btn>
                <!--<v-btn round class="elevation-0 ma-0" @click='$router.push("/criar-conta")'>
                    <v-icon left>
                        people
                    </v-icon>
                    <small>
                        Criar conta
                    </small>
                </v-btn>-->
            </v-layout>
        </v-card>

        <v-dialog v-model="dialog" max-width="500">
            <v-card class="pa-3">
                <h1 class="text-xs-center headline pa-3">Insira seu email para recuperação de senha:</h1>
                <v-text-field color="blue-grey" class="pl-3 pr-3" label="Confirme seu email de acesso" box v-model="recuperacaoEmail"></v-text-field>
                <v-btn
                    class="white--text mb-3"
                    style="background-color: #59BDB3"
                    block
                    large
                    round
                    @click="recuperacao()"
                >
                <v-icon left dark >send</v-icon>
                    Enviar
                </v-btn>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import { mapActions } from 'vuex'

	export default {
		name: 'login',
		data(){
			return{
				showPass:false,
                loader:false,
                dialog: false,
				user:{
					login:"",
					senha:""
                },
                recuperacaoEmail: ''
			}
		},
		methods:{
			...mapActions(["loginUser", "redefineSenha", "loadUserLocal"]),
			async logar()
			{
                this.loader=true
                let {login, senha} = this.user

                let result = await this.loginUser( {login, senha} )
                //console.log(login)
                if(login == 'root@root.com' && result.status)
                {
                    this.$router.push("/sumarios")
                }
                else if( login && senha && result.status ){
                    this.$router.push("/documentacao")
                    this.$store.commit('SET_SHOW_INFORME_LGPD', true)
                }
                else {
                    this.$eventHub.emit('snackBar', result)
                    this.loader=false
                }
            },
            async recuperacao()
            {
                let result = await this.redefineSenha(this.recuperacaoEmail)
                if(result.status)
                    this.$eventHub.$emit('snackBar', {color: 'success', message: result.message })

                this.dialog = false
            },
		}
	}
</script>

<style lang="stylus" scoped>
    .logo
        width 100%
        margin 0 auto

	.bodyLogin
		position fixed
		top 0
		right 0
		bottom 0
		left 0
		background url('../assets/fundo2.jpg') no-repeat


	.headerLogin
		padding 30px
		color white
		font-size 2em
		font-weight normal
		text-transform uppercase
        text-align center

	.v-card
		box-shadow 0px 0px 9px #000

</style>



// WEBPACK FOOTER //
// src/components/Login.vue